import PropTypes from 'prop-types';
import UserPanel from '../../components/UserPanel';

const UserTableName = (props) => {
  const { data } = props;

  if (data.type === 'user') {
    return (
      <div className="inline-flex-center user-name-title">
        <span>
          <UserPanel user={props} />
        </span>
      </div>
    );
  }

  return <span>{data.displayName}</span>;
};

UserTableName.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]),
};

export default UserTableName;
